"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
const TableExpandedRow_1 = __importDefault(require("@Components/ViewWork/Table/TableExpandedRow"));
const clsx_1 = __importDefault(require("clsx"));
const TableBody = ({ rows, removableCells, onRemoveCellClicked }) => (react_1.default.createElement(react_1.default.Fragment, null, rows.map((tableRow, index) => (react_1.default.createElement(TableExpandedRow_1.default, { className: (0, clsx_1.default)(index === rows.length - 1 && 'last-row'), tableRow: tableRow, removableCells: removableCells, onRemoveCellClicked: (removeCellIdentifier) => {
        onRemoveCellClicked && onRemoveCellClicked(index, removeCellIdentifier);
    }, key: `${tableRow.name}-${index}` })))));
exports.default = TableBody;
